import template from './agency.html';
import controller from './agency.controller';

let agencyComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default agencyComponent;
